import { ChevronRightIcon } from "lucide-react";
import type { ReactNode } from "react";

import Button from "../Button";

interface OnboardingWizardStepFooterProps {
	// Optional text shown above the buttons (e.g. "2 boards selected").
	note?: ReactNode;
	primary: {
		label?: ReactNode;
		onClick: () => void;
		disabled?: boolean;
	};
	secondary?: {
		label: ReactNode;
		onClick: () => void;
	};
}

// Sticky footer: pins to the column bottom as the step content scrolls.
const OnboardingWizardStepFooter = ({
	note,
	primary,
	secondary,
}: OnboardingWizardStepFooterProps) => (
	<div className="sticky bottom-0 z-10 flex shrink-0 flex-col gap-3 bg-white dark:bg-slate-800">
		{note && (
			<p className="text-slate-400 text-sm dark:text-slate-300">{note}</p>
		)}

		<Button type="button" onClick={primary.onClick} disabled={primary.disabled}>
			{primary.label ?? "Next"}
			<ChevronRightIcon className="ml-1 size-4.5" />
		</Button>

		{secondary && (
			<Button type="button" variant="outlined" onClick={secondary.onClick}>
				{secondary.label}
			</Button>
		)}
	</div>
);

export default OnboardingWizardStepFooter;
